"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const ConnectionWithTariffs_1 = tslib_1.__importDefault(require("./ConnectionWithTariffs"));
class Address extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: '1234_AB_1',
        description: 'The addresskey, in the format <POSTAL_CODE>_<HOUSE_NR>_<EXTENSION>',
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], Address.prototype, "addressKey", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => ConnectionWithTariffs_1.default),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", Array)
], Address.prototype, "connections", void 0);
exports.default = Address;
